import apiClient from '../../apiClient'

/**
 * Base API client class for making HTTP requests
 */
export class ApiClient {
  /**
   * GET request
   */
  async get(url, config = {}) {
    return await apiClient.get(url, config)
  }

  /**
   * POST request
   */
  async post(url, data = {}, config = {}) {
    return await apiClient.post(url, data, config)
  }

  /**
   * PUT request
   */
  async put(url, data = {}, config = {}) {
    return await apiClient.put(url, data, config)
  }

  /**
   * DELETE request
   */
  async delete(url, config = {}) {
    return await apiClient.delete(url, config)
  }

  /**
   * PATCH request
   */
  async patch(url, data = {}, config = {}) {
    return await apiClient.patch(url, data, config)
  }
}

export default ApiClient